<template>
  <Submenu :key="'sub-'+item.pathName" :name="item.pathName">
    <template slot="title">
      <div class="flex">
        <i :class="item.menuIcon" :size="iconSize" v-if="item.menuIcon"></i>
        <span class="layout-text">{{item.menuName}}</span>
      </div>
      <Badge
        :count="$store.getters.inboxCount"
        style="position: absolute; right: 1rem;top: 0;bottom: 0;margin: auto;height: fit-content;"
        v-if="item.menuCode == 'inbox'"
      ></Badge>
      <Badge
        :count="$store.getters.todoCount"
        style="position: absolute; right: 1rem;top: 0;bottom: 0;margin: auto;height: fit-content;"
        v-if="item.menuCode == 'workflow.config.myaffairs.todo'"
      ></Badge>
    </template>
    <template v-for="child in item.children">
      <sub-side-menu
        :item="child"
        :key="'menu-sub-'+child.menuCode"
        v-if="child.children&&child.children.length!==0"
      ></sub-side-menu>
      <menu-item :key="'menu-sub-p-'+child.menuCode" :name="child.pathName" v-else>
        <!-- <i :class="child.menuIcon ||" :size="iconSize"></i> -->
        <span class="layout-text">{{child.menuName}}</span>
        <Badge
          :count="$store.getters.inboxCount"
          style="position: absolute; right: 1rem;top: 0;bottom: 0;margin: auto;height: fit-content;"
          v-if="child.menuCode == 'inbox'"
        ></Badge>
        <Badge
          :count="$store.getters.todoCount"
          style="position: absolute; right: 1rem;top: 0;bottom: 0;margin: auto;height: fit-content;"
          v-if="child.menuCode == 'workflow.config.myaffairs.todo'"
        ></Badge>
        <Badge
          :count="$store.getters.announcementCount"
          style="position: absolute; right: 1rem;top: 0;bottom: 0;margin: auto;height: fit-content;"
          v-if="child.menuCode == 'announcement.published'"
        ></Badge>
      </menu-item>
    </template>
  </Submenu>
</template>
<script>
export default {
  name: 'subSideMenu',
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    iconSize: Number,
  },
  methods: {
    itemTitle (data) {
      if (typeof data.meta.title === 'object') {
        return this.$t(data.meta.title.i18n)
      } else {
        return data.meta.title
      }
    }
  },
}
</script>